import { createAction } from 'store/helper';

export enum TrialExpiringModalEnum {
  BUTTON_CLICKED = 'TRIAL_EXPIRING_MODAL/BUTTON_CLICKED',
}

export const TrialExpiringModalActions = {
  buttonClicked: () => createAction(TrialExpiringModalEnum.BUTTON_CLICKED),
};
